'use strict';

var React = require('react');
var usePrevious = require('./usePrevious.js');

const useMaybeControlledValue = ({ valueFromProps, onChangeFromProps, defaultValue, }) => {
    const [valueFromState, setValueFromState] = React.useState(defaultValue);
    const isControlled = valueFromProps !== undefined && onChangeFromProps !== undefined;
    const previousIsControlled = usePrevious.usePrevious(isControlled);
    if (typeof previousIsControlled === 'boolean' && isControlled !== previousIsControlled) {
        throw new Error('A maybe controlled component must be either controlled OR uncontrolled for its whole lifetime');
    }
    if (!isControlled && (valueFromProps !== undefined || onChangeFromProps !== undefined)) {
        throw new Error('To control the value, provide both value and change handler');
    }
    const value = isControlled ? valueFromProps : valueFromState;
    const onChange = isControlled ? onChangeFromProps : setValueFromState;
    return [value, onChange, { isControlled }];
};

exports.useMaybeControlledValue = useMaybeControlledValue;
//# sourceMappingURL=useMaybeControlledValue.js.map
